export default __webpack_public_path__ + "af685c3122d7d2deee04ba3aeabf7f8d.png";